export class EntraIdRestoreAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "primaryDomain",
            "baseName": "primaryDomain",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreAzureCloudAccountId",
            "baseName": "restoreAzureCloudAccountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraIdRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
